import * as Panels from './panels';
import * as Pure from './pure';
import { ComponentsRegistry } from './registry.interfaces';
import * as Smart from './smart';
import * as Templates from './templates';

export const COMPONENTS = {
  PURE: generateComponentsNames(Pure, 'Ebx'),
  PANELS: generateComponentsNames(Panels, 'Ebx'),
  TEMPLATES: generateComponentsNames(Templates, 'EbxCore'),
  SMART: generateComponentsNames(Smart, 'EbxCore')
};

export const Components = {
  Templates,
  Smart,
  Panels,
  Pure
};

function generateComponentsNames<ComponentsBarrel>(componentsBarrel: ComponentsBarrel, prefix: string) {
  return Object.keys(componentsBarrel)
    .reduce((componentsRegistry, name) => {
      // Safe cast here. Name real type is `keyof ComponentsBarrel`.
      componentsRegistry[name as keyof ComponentsBarrel] = `${ prefix }${ name }`;
      return componentsRegistry;
    }, {} as ComponentsRegistry<ComponentsBarrel>);
}
